module.exports = __webpack_public_path__ + "assets/media/2.49560d84.wav";